__turbopack_context__.v({
  "faq__item": "faq-module__O8tnPq__faq__item",
});
